<template>
  <div class="aiClass-container">
      <div class="aiClass" v-if="courseList.course.length">
        <div class="aiClass-top fbox fbox-ac">
          <div :class="activeIndex === 0?'type00':activeIndex === 1?'type01':'type02' ">{{courseList.name}}</div>
          <!-- <p>{{courseList.course.length}}门{{activeIndex=== 0?'基础':activeIndex===1?'核心':'拓展'}}课程，共{{courseList.num ? courseList.num : 0}}课节。完成基础学习即可达到阶段</p> -->
          <p>{{courseList.course.length}}门{{activeIndex=== 0?'基础':activeIndex===1?'核心':'拓展'}}课程，共{{courseList.preinstallNum || 0}}个课时。完成基础学习即可达到阶段</p>
        </div>
        <div class="class-list">
          <course :courseList='courseList.course' :status='courseList.name' :curriculaVariable='curriculaVariable' @joinCourse='joinCourse($event)' :type='type' @toDetail='toCourseDetail($event)' />
        </div>
      </div>
  </div>
</template>

<script>
import course from '@/components/course'
export default {
  name: 'aiClass',
  props: ['courseList', 'curriculaVariable', 'activeIndex'],
  components: {
    course
  },
  data () {
    return {
      type: 'aiClass'
    }
  },
  mounted () {
    console.log(this.courseList)
  },
  methods: {
    toCourseDetail (id) {
      this.$emit('toCourseDetail', id)
    },
    joinCourse (id) {
      this.$emit('joinCourse', id)
    }
  }
}
</script>

<style lang='scss' scoped>
.aiClass-container{
  .aiClass{
    background-color: #FFF5DC;
    border-radius: 9px;
    .core{
      div{
        background: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/776f04e0-fdca-4c8d-8b8e-72a6ec8a417a.png') no-repeat !important;
      }
    }
    .expand{
      div{
        background: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/62f59446-b878-4c51-b095-f7c087381da7.png') no-repeat !important;
      }
    }
    .aiClass-top{
      div{
        width: 200px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        background-size: 100% 100%;
        font-size: 28px;
        font-weight: bold;
        border-radius: 0 0 20px 0;
      }
      p{
        font-size: 20px;
        color: #827772;
        margin-left: 35px;
      }
    }
  }
}
.class-list{
  padding: 20px 30px;
  box-sizing: border-box;
}
@media(max-width: 992px) {
  .aiClass-top{
    div{
      width: 150px !important;
      height: 40px !important;
      line-height: 40px !important;
      font-size: 18px !important;
    }
    p{
      font-size: 14px !important;
      margin-left: 15px !important;
    }
  }
  .class-list{
    padding: 10px 10px !important;
  }

}
</style>
